define(
	'C3.ShoppingExtensions.Resources.Macro.View',
	[
		    'SCView'
		,   'resources_macro_view.tpl'
		,   'AjaxRequestsKiller'
		,   'Utils'
		],
	function(
		   SCViewComponent
		,  resources_macro_view_tpl
		,   AjaxRequestsKiller
		,   Utils
		) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function ResourcesMacroView(options) {
			SCView.call(this);

			//console.log(options)

			this.options = options || {};

			this.template = resources_macro_view_tpl;	
			this.model = options.model;
			this.application = options.application;
		}

		// Inherit parent instance methods.
		ResourcesMacroView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		ResourcesMacroView.prototype.constructor = ResourcesMacroView;

		ResourcesMacroView.prototype.getContext = function() {
			
			return {
				url : this.model.get('url'),
				img : this.model.get('img'),
				name : this.model.get('name'),
				isPhoneDevice : Utils.isPhoneDevice()
			};
		}

		return ResourcesMacroView;
	}

);
